exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1M9JF {\n  margin-left: -15px;\n  margin-right: -15px;\n  margin-top: 10px;\n}\n", ""]);

// Exports
exports.locals = {
	"list": "_1M9JF"
};